import React, { useState, useRef, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getRadio } from "../lib/api";

const RadioPlayer = () => {
  const { data } = useQuery({ queryKey: ["radio"], queryFn: getRadio, refetchInterval: 600000 });
  const stations = data?.stations || [];
  const [idx, setIdx] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [err, setErr] = useState(false);
  const audioRef = useRef(null);
  const current = stations[idx];

  useEffect(() => { setPlaying(false); setErr(false); if (audioRef.current) audioRef.current.pause(); }, [idx]);

  const toggle = async () => {
    const a = audioRef.current;
    if (!a || !current) return;
    if (playing) { a.pause(); setPlaying(false); return; }
    setErr(false);
    a.src = current.url;
    try { await a.play(); setPlaying(true); }
    catch { setErr(true); setPlaying(false); }
  };

  return (
    <div className="panel entrance radio-panel" data-testid="radio-panel">
      <div className="panel-head">
        <div className="panel-title">
          <div className="p-ic" style={{ background: "linear-gradient(135deg,#7a3cff,#4b2bd6)" }}>
            <i className="fa-solid fa-tower-broadcast" />
          </div>
          Live Barbados Radio
        </div>
        <span className="pill neutral" data-testid="radio-count">{stations.length} stations</span>
      </div>

      {stations.length === 0 ? (
        <div className="radio-empty" data-testid="radio-empty">
          <i className="fa-solid fa-satellite-dish" /> Scanning for live streams…
        </div>
      ) : (
        <>
          <div className="radio-now" data-testid="radio-now">
            <button className={`radio-play ${playing ? "on" : ""}`} onClick={toggle} data-testid="radio-play-btn"
              aria-label={playing ? "Stop" : "Play"}>
              <i className={`fa-solid ${playing ? "fa-stop" : "fa-play"}`} />
            </button>
            <div className="radio-meta">
              <div className="radio-name">{current?.name}</div>
              <div className="radio-sub">
                {playing ? <span className="radio-onair"><span className="live-dot" /> ON AIR</span> : "Tap play to listen live"}
                {current?.bitrate ? ` · ${current.bitrate}kbps` : ""}{current?.codec ? ` · ${current.codec}` : ""}
              </div>
              {err && <div className="radio-err" data-testid="radio-err">Stream unavailable — try another station.</div>}
            </div>
          </div>
          <select className="radio-select" value={idx} onChange={(e) => setIdx(Number(e.target.value))} data-testid="radio-select">
            {stations.map((s, i) => (
              <option key={s.url + i} value={i}>{s.name}{s.tags ? ` — ${String(s.tags).split(",").slice(0, 2).join(", ")}` : ""}</option>
            ))}
          </select>
        </>
      )}
      <audio ref={audioRef} style={{ display: "none" }} data-testid="radio-audio"
        onError={() => { setErr(true); setPlaying(false); }} onEnded={() => setPlaying(false)} />
    </div>
  );
};

export default RadioPlayer;
